import React from 'react';


export class Textarea extends React.Component {
    render() {
        let {
            color = 'main',
            height = 'auto',
            value = '',
            placeholder = '',
            disabled = false,
            silentDisabled = false,
            style = {},
            onChange = () => {},
            onKeyDown = () => {},
            onBlur = () => {},
            onPaste = () => {}
        } = this.props;

        style.height = height;
        if (silentDisabled) {
            style = {...style, cursor: 'wait', borderStyle: 'solid'};
        }

        return (
            <textarea
                ref={(this.props?.forwardedRef == null ? React.createRef() : this.props.forwardedRef)}
                className={'imd-form-control imd-text-' + color}
                style={style}
                value={value}
                placeholder={placeholder}
                onChange={(event) => onChange(event)}
                onKeyDown={(event) => onKeyDown(event)}
                onBlur={(event) => onBlur(event)}
                onPaste={(event) => onPaste(event)}
                disabled={disabled || silentDisabled}
            />
        );
    }
}
